import { Injectable } from '@angular/core';
import { StylistBusinessService } from 'src/app/core/business/stylist/stylist-business.service';

@Injectable({
  providedIn: 'root'
})
export class StylistFacadesService {

  constructor(private stylistBusinessService: StylistBusinessService) { }

  onboardStylist(data) {
    return this.stylistBusinessService.onboardStylist(data);
  }

  stylistEmail(data) {
    return this.stylistBusinessService.stylistEmail(data);
  }

}
